import { getEnvironmentVariable } from '@didaskill/utils/web';

export default {
  app: {
    name: 'eversity/backoffice',
    env: getEnvironmentVariable('ENVIRONMENT'),
  },

  sentry: {
    dsn: getEnvironmentVariable('BACKOFFICE_WEB_SENTRY_DSN'),
    env: getEnvironmentVariable('ENVIRONMENT'),
    enabled: getEnvironmentVariable('BACKOFFICE_WEB_SENTRY_ENABLED', {
      transform: (v) => v === 'true',
      defaultValue: getEnvironmentVariable('SENTRY_ENABLED', {
        transform: (v) => v === 'true',
        defaultValue: true,
      }),
    }),
  },
} as const;
